module.exports = __webpack_public_path__ + "static/img/14.e0a3ba4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/14.jpg
// module id = EW/i
// module chunks = 1